import BADGE1 from "../assets/meta-front-end-developer-certificate.png";

export const certificationsData = [
  {
    id: 1,
    badge: BADGE1,
    name: "Meta Front-End Developer Professional Certificate",
    issuer: "Meta",
    platform: "Coursera",
    year: 2024,
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/professional-cert/TQP9ZO6RQDJM",
    description:
      "Meta professional certificate covering core web technologies (HTML, CSS, JavaScript), React fundamentals, component‑based UI development, Git workflows, testing basics, and accessible, responsive interface implementation through practical projects.",
  },
];
